import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container my-4" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_4 = {
  key: 1,
  class: "alert alert-warning"
}
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "border rounded-3 p-3" }
const _hoisted_7 = { class: "d-flex flex-wrap gap-4" }
const _hoisted_8 = { class: "form-check" }
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "col-md-8" }
const _hoisted_15 = { class: "input-group" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_23 = { class: "form-check form-switch mt-md-4 pt-md-2" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = { class: "col-12 mt-3" }
const _hoisted_33 = {
  type: "submit",
  class: "btn btn-primary"
}

import { computed, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import api from "@/api";
import { ListasPreciosApi } from "@/api/listasPrecios";

interface Cliente {
  _id?: string;
  razon_social?: string | null;
  nombres: string | null;
  apellido: string | null;
  dni: string | null;
  cuit_cuil: string;
  nro_iibb: string | null;
  situacion_iva: string | null;
  direccion: string | null;
  localidad: string | null;
  telefono1: string | null;
  telefono2: string | null;
  email: string | null;
  grupo_ids: string[];
  lista_precio_id?: string | null;
  es_cliente: boolean;
  es_proveedor: boolean;
  activo?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EditarCliente',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const id = route.params.id as string | undefined;
const esNuevo = !id;
const contextoProveedor = computed(() => route.query.tipo === "proveedor");
const rutaVolver = computed(() => contextoProveedor.value ? "/proveedores" : "/clientes");
const grupos = ref<{ _id: string; nombre: string }[]>([]);
const listasPrecios = ref<
  { _id: string; nombre: string; es_default: boolean }[]
>([]);

const cliente = ref<Partial<Cliente>>({
  grupo_ids: [],
  es_cliente: true,
  es_proveedor: true,
});
const consultandoArca = ref(false);

const opcionesIVA = [
  "Responsable Inscripto",
  "Monotributo",
  "Exento",
  "Consumidor Final",
];
const camposRequeridos = ["cuit_cuil"];
const esRequerido = (key: string) => camposRequeridos.includes(key);
const error = ref<string | null>(null);

const limpiarCuit = (value: string | null | undefined) =>
  String(value || "").replace(/\D/g, "");

const aplicarDatosArca = (data: Record<string, any>) => {
  const cuit = limpiarCuit(data.cuit_cuil || cliente.value.cuit_cuil);
  const esJuridica =
    ["30", "33", "34"].includes(cuit.slice(0, 2)) ||
    Boolean(data?.arca?.tipo_persona?.toUpperCase?.().includes?.("JURID"));
  const razonSocialArca =
    data.razon_social ||
    (esJuridica && (data.nombre_principal || data.nombres || data.apellido)
      ? data.nombre_principal || data.nombres || data.apellido
      : null);
  const usaRazonSocial = Boolean(razonSocialArca);
  const nombres = data.nombres ?? (usaRazonSocial ? "" : cliente.value.nombres ?? "");
  const apellido = data.apellido ?? (usaRazonSocial ? "" : cliente.value.apellido ?? "");
  const razonSocialFinal =
    razonSocialArca ||
    (esJuridica ? [apellido, nombres].filter(Boolean).join(" ").trim() || null : null);
  cliente.value = {
    ...cliente.value,
    cuit_cuil: data.cuit_cuil || cliente.value.cuit_cuil || "",
    razon_social: razonSocialFinal ?? cliente.value.razon_social ?? "",
    nombres: esJuridica && (usaRazonSocial || razonSocialFinal) ? "" : nombres,
    apellido: esJuridica && (usaRazonSocial || razonSocialFinal) ? "" : apellido,
    direccion: data.direccion ?? cliente.value.direccion ?? "",
    localidad: data.localidad ?? cliente.value.localidad ?? "",
    situacion_iva: data.situacion_iva ?? cliente.value.situacion_iva ?? "",
  };
};

const consultarArca = async () => {
  const cuit = limpiarCuit(cliente.value.cuit_cuil);
  if (cuit.length !== 11) {
    error.value = "Ingresá un CUIT válido de 11 dígitos antes de consultar ARCA.";
    return;
  }

  consultandoArca.value = true;
  error.value = null;
  try {
    const res = await api.get("/clientes/consultar-arca", {
      params: { cuit },
    });
    aplicarDatosArca(res.data || {});
  } catch (err: any) {
    error.value =
      err?.response?.data?.detail?.mensaje ||
      err?.response?.data?.detail ||
      "No se pudo consultar ARCA.";
  } finally {
    consultandoArca.value = false;
  }
};

const cargarCliente = async () => {
  if (!esNuevo && id) {
    try {
      const res = await api.get(`/clientes/${id}`);
      cliente.value = res.data;
      if (cliente.value.activo === undefined) cliente.value.activo = true;
      if (cliente.value.es_cliente == null) cliente.value.es_cliente = true;
      if (cliente.value.es_proveedor == null) cliente.value.es_proveedor = true;
      if (!cliente.value.grupo_ids) cliente.value.grupo_ids = [];
      if (!cliente.value.lista_precio_id) cliente.value.lista_precio_id = "";
    } catch (err) {
      error.value =
        "No se pudo cargar el cliente. Verificá que el ID sea válido.";
    }
  }
};

const irAGrupos = () => {
  if (id) {
    router.push({ path: "/grupos", query: { volverACliente: id } });
  } else {
    router.push("/grupos");
  }
};

const listarGrupos = async () => {
  try {
    const res = await api.get("/grupos");
    grupos.value = res.data;
  } catch (err) {
    error.value = "No se pudo cargar grupos.";
  }
};

const cargarListasPrecios = async () => {
  try {
    listasPrecios.value = await ListasPreciosApi.listar();
    if (!cliente.value.lista_precio_id) {
      cliente.value.lista_precio_id =
        listasPrecios.value.find((item) => item.es_default)?._id || "";
    }
  } catch (err) {
    error.value = "No se pudieron cargar las listas de precios.";
  }
};

const guardarCliente = async () => {
  const payload = { ...cliente.value };
  delete payload._id;
  if (!payload.es_cliente && !payload.es_proveedor) {
    error.value = "La persona debe ser cliente, proveedor o ambas.";
    return;
  }
  const cuit = limpiarCuit(payload.cuit_cuil);
  if (cuit.length !== 11) {
    error.value = "El CUIT debe tener 11 dígitos.";
    return;
  }
  payload.cuit_cuil = cuit;

  for (const key in payload) {
    if (payload[key] === undefined || payload[key] === "") {
      payload[key] = null;
    }
  }

  try {
    if (id && !esNuevo) {
      await api.put(`/clientes/${id}`, payload);
    } else {
      await api.post("/clientes/", payload);
    }
    router.push(rutaVolver.value);
  } catch (e: any) {
    if (e?.response?.status === 401) {
      error.value =
        "Tu sesión expiró o no es válida. Volvé a iniciar sesión.";
    } else {
      error.value =
        e?.response?.data?.detail?.mensaje ||
        e?.response?.data?.detail ||
        "Error al guardar el cliente.";
    }
    console.error("Error guardando cliente:", e);
  }
};

onMounted(() => {
  cargarCliente();
  listarGrupos();
  cargarListasPrecios();
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(esNuevo ? "Nueva persona" : "Editar persona"), 1),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (cliente.value.activo === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Esta persona está inactiva. "))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _withModifiers(guardarCliente, ["prevent"]),
      class: "row g-3"
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("fieldset", _hoisted_6, [
          _cache[19] || (_cache[19] = _createElementVNode("legend", { class: "float-none w-auto px-2 fs-6 mb-2" }, "Clasificación", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                id: "es_cliente",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cliente.value.es_cliente) = $event)),
                class: "form-check-input",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, cliente.value.es_cliente]
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("label", {
                class: "form-check-label",
                for: "es_cliente"
              }, "Cliente", -1))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                id: "es_proveedor",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((cliente.value.es_proveedor) = $event)),
                class: "form-check-input",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, cliente.value.es_proveedor]
              ]),
              _cache[18] || (_cache[18] = _createElementVNode("label", {
                class: "form-check-label",
                for: "es_proveedor"
              }, "Proveedor", -1))
            ])
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "form-text" }, "Una persona puede ser cliente, proveedor o ambas.", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[21] || (_cache[21] = _createElementVNode("label", {
          for: "razon_social",
          class: "form-label"
        }, "Razón social", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cliente.value.razon_social) = $event)),
          id: "razon_social",
          type: "text",
          class: "form-control"
        }, null, 512), [
          [_vModelText, cliente.value.razon_social]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[22] || (_cache[22] = _createElementVNode("label", {
          for: "nombres",
          class: "form-label"
        }, "Nombres", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cliente.value.nombres) = $event)),
          id: "nombres",
          type: "text",
          class: "form-control"
        }, null, 512), [
          [_vModelText, cliente.value.nombres]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[23] || (_cache[23] = _createElementVNode("label", {
          for: "apellido",
          class: "form-label"
        }, "Apellido", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((cliente.value.apellido) = $event)),
          id: "apellido",
          type: "text",
          class: "form-control"
        }, null, 512), [
          [_vModelText, cliente.value.apellido]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[24] || (_cache[24] = _createElementVNode("label", {
          for: "dni",
          class: "form-label"
        }, "DNI", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((cliente.value.dni) = $event)),
          id: "dni",
          type: "text",
          class: "form-control"
        }, null, 512), [
          [_vModelText, cliente.value.dni]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[25] || (_cache[25] = _createElementVNode("label", {
          for: "cuit_cuil",
          class: "form-label"
        }, "CUIT/CUIL", -1)),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((cliente.value.cuit_cuil) = $event)),
            id: "cuit_cuil",
            type: "text",
            class: "form-control",
            required: ""
          }, null, 512), [
            [_vModelText, cliente.value.cuit_cuil]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            disabled: consultandoArca.value,
            onClick: consultarArca
          }, [
            _createVNode(_component_FontAwesomeIcon, { icon: "magnifying-glass" }),
            _createTextVNode(" " + _toDisplayString(consultandoArca.value ? "Consultando..." : "Consultar Arca"), 1)
          ], 8, _hoisted_16)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _cache[26] || (_cache[26] = _createElementVNode("label", {
          for: "nro_iibb",
          class: "form-label"
        }, "Nro IIBB", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((cliente.value.nro_iibb) = $event)),
          id: "nro_iibb",
          type: "text",
          class: "form-control"
        }, null, 512), [
          [_vModelText, cliente.value.nro_iibb]
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _cache[28] || (_cache[28] = _createElementVNode("label", {
          for: "situacion_iva",
          class: "form-label"
        }, "Situación IVA", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((cliente.value.situacion_iva) = $event)),
          id: "situacion_iva",
          class: "form-select",
          required: ""
        }, [
          _cache[27] || (_cache[27] = _createElementVNode("option", {
            disabled: "",
            value: ""
          }, "Seleccionar...", -1)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(opcionesIVA, (op) => {
            return _createElementVNode("option", {
              key: op,
              value: op
            }, _toDisplayString(op), 9, _hoisted_19)
          }), 64))
        ], 512), [
          [_vModelSelect, cliente.value.situacion_iva]
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _cache[30] || (_cache[30] = _createElementVNode("label", {
          for: "lista_precio_id",
          class: "form-label"
        }, "Lista de precios", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((cliente.value.lista_precio_id) = $event)),
          id: "lista_precio_id",
          class: "form-select"
        }, [
          _cache[29] || (_cache[29] = _createElementVNode("option", {
            disabled: "",
            value: ""
          }, "Seleccionar...", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listasPrecios.value, (lista) => {
            return (_openBlock(), _createElementBlock("option", {
              key: lista._id,
              value: lista._id
            }, _toDisplayString(lista.nombre) + _toDisplayString(lista.es_default ? " (default)" : ""), 9, _hoisted_21))
          }), 128))
        ], 512), [
          [_vModelSelect, cliente.value.lista_precio_id]
        ])
      ]),
      (!esNuevo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                id: "activo",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((cliente.value.activo) = $event)),
                class: "form-check-input",
                type: "checkbox",
                role: "switch"
              }, null, 512), [
                [_vModelCheckbox, cliente.value.activo]
              ]),
              _cache[31] || (_cache[31] = _createElementVNode("label", {
                class: "form-check-label",
                for: "activo"
              }, "Activo", -1))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _cache[32] || (_cache[32] = _createElementVNode("label", {
          for: "grupo_ids",
          class: "form-label"
        }, "Grupos", -1)),
        _createElementVNode("div", _hoisted_25, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((cliente.value.grupo_ids) = $event)),
            class: "form-select me-2",
            id: "grupo_ids",
            multiple: ""
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupos.value, (grupo) => {
              return (_openBlock(), _createElementBlock("option", {
                key: grupo._id,
                value: grupo._id
              }, _toDisplayString(grupo.nombre), 9, _hoisted_26))
            }), 128))
          ], 512), [
            [_vModelSelect, cliente.value.grupo_ids]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-primary",
            type: "button",
            onClick: irAGrupos
          }, [
            _createVNode(_component_FontAwesomeIcon, { icon: "plus" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _cache[33] || (_cache[33] = _createElementVNode("label", {
          for: "direccion",
          class: "form-label"
        }, "Dirección", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((cliente.value.direccion) = $event)),
          id: "direccion",
          type: "text",
          class: "form-control"
        }, null, 512), [
          [_vModelText, cliente.value.direccion]
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _cache[34] || (_cache[34] = _createElementVNode("label", {
          for: "localidad",
          class: "form-label"
        }, "Localidad", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((cliente.value.localidad) = $event)),
          id: "localidad",
          type: "text",
          class: "form-control"
        }, null, 512), [
          [_vModelText, cliente.value.localidad]
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _cache[35] || (_cache[35] = _createElementVNode("label", {
          for: "telefono1",
          class: "form-label"
        }, "Teléfono 1", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((cliente.value.telefono1) = $event)),
          id: "telefono1",
          type: "text",
          class: "form-control"
        }, null, 512), [
          [_vModelText, cliente.value.telefono1]
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _cache[36] || (_cache[36] = _createElementVNode("label", {
          for: "telefono2",
          class: "form-label"
        }, "Teléfono 2", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((cliente.value.telefono2) = $event)),
          id: "telefono2",
          type: "text",
          class: "form-control"
        }, null, 512), [
          [_vModelText, cliente.value.telefono2]
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _cache[37] || (_cache[37] = _createElementVNode("label", {
          for: "email",
          class: "form-label"
        }, "Email", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((cliente.value.email) = $event)),
          id: "email",
          type: "email",
          class: "form-control"
        }, null, 512), [
          [_vModelText, cliente.value.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("button", _hoisted_33, [
          _createVNode(_component_FontAwesomeIcon, { icon: "floppy-disk" }),
          _createTextVNode(" " + _toDisplayString(esNuevo ? "Guardar" : "Actualizar"), 1)
        ]),
        _createVNode(_component_router_link, {
          to: rutaVolver.value,
          class: "btn btn-secondary ms-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FontAwesomeIcon, { icon: "xmark" }),
            _cache[38] || (_cache[38] = _createTextVNode(" Cancelar "))
          ]),
          _: 1,
          __: [38]
        }, 8, ["to"])
      ])
    ], 32)
  ]))
}
}

})